interface UnknownObject {
  [key: string]: string | number | symbol | any
}

const container: UnknownObject = {}

export default container
